import { render, staticRenderFns } from "./couponCreateComponent.vue?vue&type=template&id=eb52b616"
import script from "./couponCreateComponent.vue?vue&type=script&lang=js"
export * from "./couponCreateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports